module.exports = __webpack_public_path__ + "static/img/zt3-pic3.473ac70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceThree/zt3-pic3.jpg
// module id = CBI8
// module chunks = 171